import { Map, Record, List } from 'immutable';
import Address          from './address';
import { parameterize } from 'helpers/string';

import JobRecord from 'records/job_record'

const struct = {
  id:                  undefined,
  title:               undefined,
  positionTitle:       undefined,
  campaignType:        undefined,
  locale:              undefined,
  brief:               undefined,
  description:         undefined,
  salary:              undefined,
  salaryType:          undefined,
  currencyType:        undefined,
  jobType:             undefined,
  remoteType:          undefined,
  createdAt:           undefined,
  updatedAt:           undefined,
  deletedAt:           undefined,
  origin:              new Map(),
  bearerToken:         undefined,
  address:             new Address(),
  facebookPixelId:     undefined,
  jobBanner:           undefined,
  settings:            {},
  companyJobBanner:    undefined,
  companyParameters:   {},
  company:             new Map(),
  countryShortCode:    undefined,
  prompts:             new List(),
  evaluationCriterias: new List(),
  talkscoreWeightDistribution: new Map(),
  jobLandingPageUrl:   undefined,
  messengerUrl:        undefined,
  applyResume:         undefined,
};

export default class CampaignRecord extends Record(struct, 'CampaignRecord') {
  cityLocation() {
    if (this.remoteType) return t(this.remoteType, { scope: 'eos.landing_page.text.remote_types', defaultValue: this.remoteType });

    const address = new Address(this.address);

    return address.cityLocation();
  }

  isLongForm() {
    return this.settings.landingPageType == 'single';
  }

  isOnboarding() {
    return this.campaignType === 'onboarding';
  }

  forceNewLandingPage() {
    return this.companyParameters.eosLandingPage === true;
  }

  hasFallbackBanner() {
    return this.forceNewLandingPage() && this.companyJobBanner !== undefined;
  }

  forceDefaultBanner() {
    return (
      this.forceNewLandingPage()
      && this.companyParameters.useBanner === true
      && this.companyJobBanner !== undefined
    );
  }

  companyLandingPageType() {
    if (!['single', 'multiple'].includes(this.companyParameters.landingPageType) || !this.forceNewLandingPage()) {
      return null;
    }

    return this.companyParameters.landingPageType;
  }

  jobTypeTitle() {
    const jtype = this.jobType || this.origin.jobType;
    return t(parameterize(jtype), { scope: 'eos.landing_page.text.job_type_options', defaultValue: t('eos.landing_page.text.job_type_options.default') });
  }

  salaryValue() {
    if (this.salary && `${this.salary}`.trim().length > 0) {
      const details = [this.salary, this.currencyType];

      if (this.salaryType) {
        const freq = t(this.salaryType, { scope: 'eos.landing_page.text.salary_types', defaultValue: this.salaryType });
        details.push(`/ ${freq}`);
      }

      return details.filter((i) => i).join(' ');
    }

    const job = new JobRecord(this.origin);

    return job.salaryDetails()
  }

  briefValue() {
    if (this.brief && this.brief.trim().length > 0) {
      return this.brief;
    }

    return this.origin.brief;
  }

  publicJobTitle() {
    const origin = new JobRecord(this.origin);

    if (origin.isTemplate() && this.positionTitle) {
      return this.positionTitle;
    }

    return origin.title;
  }
}
